import { AdditionalIcon } from '../shared/additionalIcon/additionalIcon';
import { FilterMenuItemFieldProps } from './types/filterMenuItemFieldProps';
import './filterMenuItemField.scss';
import DatepickerField from '../datepickerField/datepickerField';
import { useEffect, useState } from 'react';
import UseDebounce from '../../helpers/debounce';

const FilterMenuDate = (props: FilterMenuItemFieldProps) => {
    const [selectedDate, setSelectedDate] = useState<Date>();

    useEffect(() => {
        if (props.active) {
            if (selectedDate != null) {
                props.onChange(selectedDate);
            }
        } else {
            props.onChange(null);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.active])

    const handleChange = (date: Date) => {
        if (date !== null) {
            props.onChange(date);
        } else {
            props.onChange(null);
        }
    }

    const handleDateChange = (value: Date) => {
        setSelectedDate(value);
        if (props.active) {
            handleChange(value);
        }
    }

    if (props.single) {
        return <div className="filter-menu-item">
            <div className="body-txt-medium filter-menu-item-label">{AdditionalIcon(props.additionalIcon)} {props.label}</div>
            <div className="">
                <DatepickerField
                    className='body-txt-small extra-date-class'
                    selected={selectedDate}
                    inputPlaceholder="Wybierz datę"
                    dateFormat='yyyy-MM-dd'
                    fixedHeight={true}
                    datepickerSharedProps={{ className: 'body-txt-small extra-date-class' }}
                    setValue={UseDebounce(handleDateChange, 500)}
                    hideLabel={true}
                    keepPristine={true}
                />
            </div>
        </div>
    }

    return (
        <div className="filter-menu-item">
            <div className="body-txt-medium filter-menu-item-label">{AdditionalIcon(props.additionalIcon)} {props.label}</div>
            <div className="filter-menu-item-date">
                <DatepickerField
                    className='body-txt-small extra-date-class'
                    selected={selectedDate}
                    inputPlaceholder="Dzień"
                    dateFormat='dd'
                    fixedHeight={true}
                    datepickerSharedProps={{ className: 'body-txt-small extra-date-class' }}
                    setValue={UseDebounce(handleDateChange, 500)}
                    hideLabel={true}
                />
                <DatepickerField
                    className='body-txt-small extra-date-class'
                    hideTodayBtn={true}
                    selected={selectedDate}
                    inputPlaceholder="Miesiąc"
                    dateFormat='MM'
                    showMonthYearPicker={true}
                    fixedHeight={true}
                    datepickerSharedProps={{ className: 'body-txt-small extra-date-class' }}
                    setValue={UseDebounce(handleDateChange, 500)}
                    hideLabel={true}
                />
                <DatepickerField
                    className='body-txt-small extra-date-class'
                    hideTodayBtn={true}
                    selected={selectedDate}
                    inputPlaceholder="Rok"
                    dateFormat='yyyy'
                    showYearPicker={true}
                    fixedHeight={true}
                    datepickerSharedProps={{ className: 'body-txt-small extra-date-class' }}
                    setValue={UseDebounce(handleDateChange, 500)}
                    hideLabel={true}
                />
            </div>
        </div>
    )
}

export default FilterMenuDate;
